const AUTO_SUGGEST_URL='https://hennis.pubtonic.dev/api/suggest';const TRACKING_URL='https://hennis.pubtonic.dev/api/track';const PIXEL_URL='pubtonic.dev';const SEARCH_URL='https://hennis.pubtonic.dev/api/braveapi';const ENV='staging';// -- deep lookup for a key within a nested object
function findVal(object, key) {
    var value;
    Object.keys(object).some(function (k) {
        if (k === key) {
            value = object[k];
            return true;
        }
        if (object[k] && typeof object[k] === 'object') {
            value = findVal(object[k], key);
            return value !== undefined;
        }
    });
    return value;
}


function randomString(length) {

    // dec2hex :: Integer -> String
    // i.e. 0-255 -> '00'-'ff'
    function dec2hex(dec) {
        return dec.toString(16).padStart(2, "0")
    }

    function generateId(len) {
        let arr = new Uint8Array((len || 40) / 2)
        window.crypto.getRandomValues(arr)
        return Array.from(arr, dec2hex).join('')
    }

    return generateId(length)
}
